/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles';

// Composables
import { createVuetify } from 'vuetify';
// `aliases` carry Vuetify's component-internal icons; routes import only the paths they use.
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import colors from 'vuetify/util/colors';

const accessibleThemeVariables = {
    'medium-emphasis-opacity': 0.7,
};

function shadesOf(color: {
    base: string;
    lighten5: string;
    lighten1: string;
    darken2: string;
    darken4: string;
}) {
    return {
        primary: color.base,
        'primary-darker': color.darken2,
        'primary-darkest': color.darken4,
        'primary-lighter': color.lighten1,
        'primary-lightest': color.lighten5,
    };
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    ssr: true,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: colors.blue.darken3,
                    'primary-darker': colors.blue.darken4,
                    'primary-darkest': '#072d69',
                    'primary-lighter': colors.blue.darken2,
                    'primary-lightest': colors.blue.lighten5,
                },
                variables: accessibleThemeVariables,
            },
            teal: {
                colors: shadesOf(colors.teal),
                variables: accessibleThemeVariables,
            },
            cyan: {
                colors: shadesOf(colors.cyan),
                variables: accessibleThemeVariables,
            },
            blue: {
                colors: shadesOf(colors.blue),
                variables: accessibleThemeVariables,
            },
            indigo: {
                colors: shadesOf(colors.indigo),
                variables: accessibleThemeVariables,
            },
            'blue-grey': {
                colors: shadesOf(colors.blueGrey),
                variables: accessibleThemeVariables,
            },
        },
    },
    defaults: {
        global: {
            transition: false,
        },
        VSelect: {
            variant: 'outlined',
        },
        VTextField: {
            variant: 'outlined',
        },
        VTextarea: {
            variant: 'outlined',
        },
    },
});
